module.exports = __webpack_public_path__ + "img/arrow-bar-up.ee9ece7e.svg";